import React from 'react';
import { node } from 'prop-types';
import SSRProvider from 'react-bootstrap/SSRProvider';
import TrafficSource from './components/TrafficSource/TrafficSource';

const propTypes = {
  element: node.isRequired,
};

const App = ({ element }) => (
  <SSRProvider>
    {element}
    <TrafficSource />
  </SSRProvider>
);

App.propTypes = propTypes;

export default App;
